/*
*	Element list model
*/
function SLR_ElementList(_element)
{
	/* Properties */
	var self = this;
	self.element = _element;
	self.elements = [];

	/* Methods */
	self.addElement = function(element)
	{
		self.elements.push(element);
	};

	self.removeElement = function(element)
	{
		var index = self.elements.indexOf(element);
		if (index >= 0){
			self.elements.splice(index, 1);
		}
	};

	self.duplicateElement = function(element)
	{
		// gather data
		var request = new FormData(),
			data = {};

		// build request
		request.append("model", "element");
		request.append("action", "duplicate");
		request.append("type", self.element.form.get_invoice_type());
		request.append("data", JSON.stringify(element.model.item));

		// add request to queue
		$.slr.db.add(request, function(x)
		{
			self.element.load_element(x.item.id);
		});
		return false;
	};

	self.setListOrder = function(list_order)
	{
		// reorder array of elements
		var elements_array = [];
		list_order.forEach(function(id){
			elements_array.push(self.getByID(id));
		});
		self.elements = elements_array;

		// gather data
		var request = new FormData(),
			data = {};

		// build request
		request.append("model", "element");
		request.append("action", "order");
		request.append("data", JSON.stringify(list_order));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	self.getByID = function(element_id)
	{
		var element = undefined;
		self.elements.forEach(function(e){
			if (e.getElementID() == element_id){
				element = e;
			}
		});
		return element;
	};

	self.getIndexOf = function(element_id)
	{
		var index_of = -1000;
		self.elements.forEach(function(e, index){
			if (e.getElementID() == element_id){
				index_of = index;
			}
		});
		return index_of;
	};

	self.getCount = function()
	{
		return self.elements.length;
	};

	self.each = function(callback)
	{
		self.elements.forEach(function(x){
			callback(x);
		});
	};
}

/*
*	Element list interface behavior
*/
$.fn.ElementList = function(_form)
{
	var _el = this;
	_el.model = new SLR_ElementList(_el);
	_el.template = undefined;
	_el.form = _form;
	_el.interface = {
		empty_element : _el.find("#slr-element-list-empty"),
		add_button : _el.find(".btn-action-add-element"),
		container : _el.find("#slr-elements-container")
	};

	_el.refresh = function()
	{
		// empty or not
		if (_el.model.getCount()){
			_el.interface.empty_element.fadeOut("fast");
		} else {
			_el.interface.empty_element.fadeIn("fast");
		}

		// show elements
		_el.model.each(function(x){
			_el.interface.container.append(x);
		});

		// update totals
		_el.form.updateTotals();
	};

	_el.add_element = function()
	{
		if (_el.form.get_invoice_type() != 3) {	// not prod
			// select previous element contract if available
			var lastContract = undefined;
			_el.model.elements.forEach(function(x){
				if (x.getContractID() != undefined && x.getContractID()){
					lastContract = x.getContractID();
				}
			});
		}

		// create new element
		var newElement = _el.template.find(".slr-el").clone();
		if (lastContract != undefined){
			newElement.find("select[name=contract_id]").val(lastContract).trigger("change");
		}
		newElement.Element(_el);
		
		// save new element
		newElement.save();
		newElement.open(); // open new element by default
		newElement.updateInterface();
		_el.model.addElement(newElement);
		_el.refresh();
		return false;
	};

	_el.remove_element = function(element)
	{
		_el.model.removeElement(element);
		_el.refresh();
	};

	_el.duplicate_element = function(element){
		_el.model.duplicateElement(element);
	}

	_el.load_element = function(element_id)
	{
		$.get("/facture/element/" + element_id, {}, function(x){
			var newElement = $($(x)[0]);
			newElement.Element(_el);
			_el.model.addElement(newElement);
			_el.refresh();
		}, 'html');
	};

	_el.elements_sorted = function()
	{
		var order = [], elements = [];
		_el.interface.container.find(".slr-el").each(function(index, el){
			order.push(parseInt($(el).find("input[name=element_id]").val(), 10));
		});
		_el.model.setListOrder(order);
	};

	_el.reloadContractFiles = function(contract)
	{
		_el.model.each(function(element){
			element.interface.tabs.contract.reloadOthers(contract);
		});
	};
	
	_el.reloadContractNotes = function(contract)
	{
		_el.model.each(function(element){
			element.interface.tabs.contract.reloadOthers(contract);
		});
	};

	return function()
	{
		_el.template = $("#slr-element-template").clone().removeAttr("id");
		_el.existing_contracts = _el.template.find(".select-plus-new").data("existing-contracts");
		$("#slr-element-template").remove();
		$("#slr-elements-container").sortable({
			helper : 'clone',
			stop : _el.elements_sorted,
			handle : '.drag-element-button',
			start: function(e, ui ){
			     ui.placeholder.height(ui.helper.outerHeight());
			},
		});
		_el.interface.add_button.on("click", _el.add_element);
		if (_el.interface.container.find(".slr-el").length) {
			_el.interface.container.find(".slr-el").each(function(){
				var loadedElement = $(this).Element(_el);
				_el.model.addElement(loadedElement);
			});
		} else {
			_el.interface.add_button.click();
		}
		return _el;
	}();
};
